import './App.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import Termsofservice from './pages/Termsofservice';

function App() {
  return (
   <>
    <Router>
      <Header/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/termsofservices" element={<Termsofservice />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
    </Routes>
      <Footer/>
    </Router>
   </>
  );
}

export default App;
